<template>
	<div class="page">
		<div class="pageTitleBox">
			<div class="boxNameL">
				关联耗材
			</div>
			<div class="boxNameR">
				<el-button type="warning" @click="isBack" size="small">返回</el-button>
			</div>
		</div>
		<el-form ref="form" style="padding-bottom: 80px;" :model="editParams" label-width="100px">
			
			<el-form-item label="关联的类型" >
				<span v-if="editParams.relation_type==1">生活服务</span>
				<span v-if="editParams.relation_type==2">医疗服务</span>
				<span v-if="editParams.relation_type==3">疫苗套餐</span>
				<span v-if="editParams.relation_type==4">驱虫套餐</span>
			</el-form-item>
			<el-form-item label="关联服务名称" >
				<span >{{editParams.product_name}}</span>
			</el-form-item>
			<el-form-item label="" >
				<el-button size="mini" type="primary" @click="dialogAddShop_state=true;tree=[{id:'6049cf035a0dfcc381f9311a'}]">关联耗材</el-button>
			</el-form-item>
			<el-form-item label="">
				<el-table :data="editParams.consumable_material_list">
					<el-table-column prop="name" label="耗材名称">
					</el-table-column>
					<el-table-column label="使用数量">
						<template slot-scope="scope">
							<el-input style="width: 120px;" type='number' size='small' v-model.number="scope.row.count" placeholder="请输入数量"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="use_unit" label="单位">
					</el-table-column>
					<el-table-column label="是否必需品">
						<template slot-scope="scope">
							<el-checkbox v-model="scope.row.is_must"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="180px">
						<template slot-scope="scope">
							<el-button size="mini" icon="el-icon-delete" type='danger' @click="editParams.consumable_material_list.splice(scope.$index,1)"></el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-form-item>
		</el-form>
		<div class="footer">
			<div style="margin: auto;">
				<el-button type="primary" size="small" :loading="loading" @click='submitData'>确定</el-button>
			</div>
		</div>
		<div v-if="dialogAddShop_state">
			<dialogNewGoods v-if="dialogAddShop_state" @closeOn="dialogAddShop_state = false" :addShopState.sync="dialogAddShop_state" :tree="tree" @submit='getgoods'></dialogNewGoods>
		</div>
	</div>
</template>

<script>
	import {
		setRelationCon,
		getRelationConDl,
	} from '../../../api/productApi.js'
	import dialogNewGoods from "../../../components/dialog_addShop.vue"
	export default{
		components: {
			dialogNewGoods
		},
		data(){
			return{
				dialogAddShop_state:false,
				editParams:{
					relation_id:'',
					relation_type:this.$route.query.relation_type,
					product_id:this.$route.query.product_id,
					product_name:this.$route.query.product_name,
					consumable_material_list:[],
				},
				tree:[],
				loading:false,
			}
		},
		methods:{
			isBack() {
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.go(-1)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			getgoods(data){
				console.log(data)
				let index = this.editParams.consumable_material_list.findIndex(item=>{
					return item._id==data.goodsItem.consumablematerial_id&&item.sku_id==data.skuItem._id
				})
				if(index==-1){
					this.editParams.consumable_material_list.push({
						_id:data.goodsItem.consumablematerial_id,
						name:data.goodsItem.title,
						use_unit:data.goodsItem.use_unit,
						count:0,
						is_must:true,
					})
				}
			},
			submitData(){
				this.loading = true;
				this.$refs['form'].validate((valid) => {
					if (valid) {
						setRelationCon(this.editParams).then(res => {
							if (res.code == 0) {
								this.loading = false;
								this.$message({
									message: '添加成功',
									type: 'success'
								});
								this.$router.go(-1)
							}
						})
					} else {
				
						return false;
					}
				});
			},
			getRelationConDl(){
				getRelationConDl({productId:this.$route.query.product_id}).then(res=>{
					if(res.code==0){
					this.editParams.consumable_material_list=res.data;
					}
				})
			}
			
		},
		created(){
			this.getRelationConDl();
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.page{
		.footer {
			background-color: #f5f5f5;
			position: fixed;
			bottom: 0;
			height: 50px;
			line-height: 50px;
			display: flex;
			justify-content: space-between;
			left: 220px;
			right: 0;
			padding-left: 20px;
			z-index: 200;
		}
	}
</style>
